const Footer = () => {
    return (
      <footer className="bg-[#2C2C2C] text-center py-3">
        <p className="text-sm text-textLight">
          &copy; {new Date().getFullYear()} Bartosz Kostuj | Wszelkie prawa zastrzeżone
        </p>
      </footer>
    );
  };
  
  export default Footer;
  